if (!customElements.get('products-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        tabButton: '[tab-btn]',
        tabContent: '[tab-content]'
      };
      this.init();
    }
    init() {
      const tabButtons = this.querySelectorAll(this.selectors.tabButton);
      const tabContents = this.querySelectorAll(this.selectors.tabContent);
      console.log(tabButtons);

      tabButtons?.forEach(button => {
        button?.addEventListener('click', () => {
          const targetTab = button.dataset.id;
          tabButtons?.forEach(btn => btn.classList.remove('active'));
          tabContents?.forEach(content => {
            content.classList.remove('active');
            content.style.maxHeight = '0px';
          });

          button.classList.add('active');
          setTimeout(() => {
            tabContents?.forEach(content => {
              if (content.getAttribute('data-tab') === targetTab) {
                content.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
              }
            });
          }, 300);
        });
      });
    }
  }
  customElements.define('products-tabs', ProductTabs);
}
